// extracted by mini-css-extract-plugin
export default {"linkedTasksList":"LinkedTasksList_linkedTasksList__ZYxu1","titleContainer":"LinkedTasksList_titleContainer__SEDbQ","title":"LinkedTasksList_title__PzJEA"};